import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../features/apiServices/apiClient";
import "./css/SignupPage.css";

export default function SignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    tenant_name: "",
    restaurant_name: "",
    restaurant_cnpj: "",
    restaurant_timezone: "America/Sao_Paulo",
    address: {
      uf: "",
      cep: "",
      rua: "",
      cidade: "",
      numero: ""
    }
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const payload = {
      name: form.name,
      email: form.email,
      password: form.password,
      tenant_name: form.tenant_name,
      restaurant_name: form.restaurant_name,
      restaurant_cnpj: form.restaurant_cnpj,
      contact_email: form.email,
      restaurant_timezone: "America/Sao_Paulo",

      mesas_iniciais: 10,
      capacidade_mesa: 4,

      address: {
        uf: form.uf,
        cep: form.cep,
        rua: form.rua,
        cidade: form.cidade,
        numero: form.numero
      }
    };



    try {
      const response = await api.post("/auth/signup", payload);

      const data = response.data;

      // NOVO – coletar tokens retornados pela API
      const { accessToken, refreshToken, tenant, user, restaurant } = data;

      // NOVO – salvar tokens corretamente
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      // salvar dados normais
      localStorage.setItem("tenant", JSON.stringify(tenant));
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("restaurants", JSON.stringify([restaurant]));

      localStorage.removeItem("activeRestaurant");

      navigate("/home");
    } catch (err) {
      console.error(err);
      setError("Erro ao criar conta. Verifique os dados e tente novamente.");
    }

    setLoading(false);
  };

  return (
    <div className="signup-container">
      {/* LOGO */}

      <div className="signup-header">
        <img
          src={"/assets/logo-mesaclick.png"}
          alt="MesaClick"
          className="signup-logo"
          onClick={() => navigate("/")}
        />

      </div>

      {/* ÁREA LADO A LADO */}
      <div className="signup-content">

        {/* CARD DE ASSINATURA */}
        <div className="signup-plan-card">
          <h2>Plano Mensal</h2>
          <p className="subtitle">Após período gratuito de 30 dias</p>

          <h1 className="price">
            R$ 899,90 <span>/ mês</span>
          </h1>

          <ul className="benefits">
            <li>✔ Pedidos via tablet (mesas)</li>
            <li>✔ Painel da cozinha (KDS)</li>
            <li>✔ Relatórios e indicadores</li>
            <li>✔ Cadastro completo de cardápio</li>
            <li>✔ Mesas ilimitadas</li>
            <li>✔ Suporte via WhatsApp</li>
            <li>✔ Atualizações contínuas</li>
          </ul>
        </div>

        {/* FORMULÁRIO DE CADASTRO */}
        <div className="signup-form-card">
          <h2>Crie sua conta</h2>
          <p className="subtitle">Vamos configurar seu restaurante</p>

          <form onSubmit={handleSignup} className="signup-form">

            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Seu nome"
                value={form.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="E-mail"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <input
                type="password"
                name="password"
                placeholder="Senha"
                value={form.password}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="tenant_name"
                placeholder="Nome da empresa"
                value={form.tenant_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                name="restaurant_name"
                placeholder="Nome do restaurante"
                value={form.restaurant_name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="restaurant_cnpj"
                placeholder="CNPJ"
                value={form.restaurant_cnpj}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                name="uf"
                placeholder="UF"
                value={form.uf}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="cep"
                placeholder="CEP"
                value={form.cep}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                name="rua"
                placeholder="Rua"
                value={form.rua}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="cidade"
                placeholder="Cidade"
                value={form.cidade}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                name="numero"
                placeholder="Número"
                value={form.numero}
                onChange={handleChange}
                required
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            <button type="submit" className="signup-btn" disabled={loading}>
              {loading ? "Criando conta..." : "Criar Conta"}
            </button>

            <p className="login-link">
              Já tem conta?
              <span className="nav-btn" onClick={() => navigate("/login")}> Entrar</span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );

}
